import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import API_URL from "../../src/Config";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { MdAttachFile } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { FiUpload } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";

function EditActualManpower({ isSidebarExpanded }) {
  const getBackendValidationMessage = (
    error,
    fallbackMessage = "Error submitting form. Please try again."
  ) => {
    const errorData = error?.response?.data;

    if (!errorData) {
      return fallbackMessage;
    }

    if (typeof errorData === "string" && errorData.trim()) {
      return errorData.trim();
    }

    if (typeof errorData.error === "string" && errorData.error.trim()) {
      return errorData.error.trim();
    }

    if (typeof errorData.message === "string" && errorData.message.trim()) {
      return errorData.message.trim();
    }

    if (Array.isArray(errorData.errors)) {
      const combinedErrors = errorData.errors
        .flatMap((item) =>
          Array.isArray(item)
            ? item
            : typeof item === "string"
            ? [item]
            : Object.values(item || {}).flat()
        )
        .filter(Boolean)
        .join(", ");

      if (combinedErrors) {
        return combinedErrors;
      }
    }

    if (errorData.errors && typeof errorData.errors === "object") {
      const combinedErrors = Object.values(errorData.errors)
        .flatMap((value) => (Array.isArray(value) ? value : [value]))
        .filter(Boolean)
        .join(", ");

      if (combinedErrors) {
        return combinedErrors;
      }
    }

    return fallbackMessage;
  };

  const navigate = useNavigate();
  const { id } = useParams();
  const [projectId, setProjectId] = useState("");
  const [manPowerData, setManPowerData] = useState({
    project_id: id || "",
    // man_power_id: id || "",
    person_name: "",
    contact_no: "",
    email: "",
    status: "",
    ec_no: "",
    joining_attachments: "",
    site_clr_attachments: "",
    joining_expected_date: "",
    position: "",
    leaving_expected_date: "",
    resigned_letter: "",
  });
  const [positionOptions, setPositionOptions] = useState([]);
  const fileInputRef = useRef(null);
  const resignedletterFileInputRef = useRef(null);
  const joinFileInputRef = useRef(null);
  const [isJoinPopupOpen, setIsJoinPopupOpen] = useState(false);
  const [isResignedLetterPopupOpen, setIsResignedLetterPopupOpen] =
    useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedJoinFiles, setSelectedJoinFiles] = useState([]);
  const [selectedResignedLetterFiles, setSelectedResignedLetterFiles] =
    useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [severity, setSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedLeavingDate, setSelectedLeavingDate] = useState(null);
  const [selectedInstallationDate, setSelectedInstallationDate] =
    useState(null);
  const [showAttachment, setShowAttachment] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedProject, setSelectedProject] = useState(null); // Stores selected project
  const [projects, setProjects] = useState([]);
  const [existingResignedLetterFile, setExistingResignedLetterFile] =
    useState(null);
  const [existingJoinFiles, setExistingJoinFiles] = useState([]);
  const [existingSiteFile, setExistingSiteFile] = useState(null);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };

  useEffect(() => {
    const fetchActualManpowerData = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(
          `${API_URL}/api/get_actual_manpower/${id}`,
          {
            headers: {
              Authorization: authKey,
            },
          }
        );
        const responseData = response.data;
        console.log("responseData", responseData);
        const grouped = responseData?.files?.reduce((acc, file) => {
          const type = file.file_type;
          if (!acc[type]) acc[type] = [];
          acc[type].push(file);
          return acc;
        }, {});

        // ✅ Only save the first
        if (grouped?.resigned_letter && grouped?.resigned_letter.length > 0) {
          setExistingResignedLetterFile(grouped.resigned_letter[0]);
        } else {
          setExistingResignedLetterFile(null);
        }

        const groupedSiteClearance = responseData?.files?.reduce(
          (acc, file) => {
            const type = file.file_type;
            if (!acc[type]) acc[type] = [];
            acc[type].push(file);
            return acc;
          },
          {}
        );

        // ✅ Only save the first
        if (
          groupedSiteClearance?.site_clearance &&
          groupedSiteClearance?.site_clearance.length > 0
        ) {
          setExistingSiteFile(groupedSiteClearance.site_clearance[0]);
        } else {
          setExistingSiteFile(null);
        }

        const groupedJoining = responseData?.files?.reduce((acc, file) => {
          const type = file.file_type;
          if (!acc[type]) acc[type] = [];
          acc[type].push(file);
          return acc;
        }, {});

        // Get the FIRST resigned letter file (or null if none)
        if (groupedJoining?.joining && groupedJoining?.joining?.length > 0) {
          setExistingJoinFiles(groupedJoining?.joining);
        } else {
          setExistingJoinFiles(null);
        }

        // Only format date if it's not null
        const formattedJoiningDate = responseData.joining_expected_date
          ? new Date(responseData.joining_expected_date)
              .toISOString()
              .split("T")[0]
          : null;

        const formattedLeavingDate = responseData.excepted_date_leaving
          ? new Date(responseData.excepted_date_leaving)
              .toISOString()
              .split("T")[0]
          : null;

        const formattedData = {
          person_name: responseData.person_name || "",
          contact_no: responseData.contact_no || "",
          email: responseData.email || "",
          ec_no: responseData.ec_no || "",
          status: responseData.status || "",
          position: responseData.position || "",
          joining_expected_date: formattedJoiningDate, // Keep null if null
          project_id: responseData.project_id || "",
          man_power_id: responseData.man_power_id || "",
          project_name: responseData.project_name,
          leaving_expected_date: formattedLeavingDate, // Keep null if null
        };

        setManPowerData(formattedData);
        setProjectId(responseData.project_id || "");
        setSelectedProject({
          value: responseData.project_id,
          label: responseData.project_name,
        });

        setSelectedStatus(
          statusOptions.find(
            (option) => option.value === formattedData.status
          ) || null
        );
        setSelectedPosition(
          positionOptions.find(
            (option) => option.label === formattedData.position
          ) || null
        );

        // Set selected date (null if joining_expected_date is null)
        setSelectedDate(
          formattedData.joining_expected_date
            ? new Date(formattedData.joining_expected_date)
            : null
        );

        setSelectedLeavingDate(
          formattedData.leaving_expected_date
            ? new Date(formattedData.leaving_expected_date)
            : null
        );
      } catch (error) {
        console.error("Error fetching department data:", error.message);
        setError("An error occurred while fetching department data");
      }
    };

    fetchActualManpowerData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setManPowerData({ ...manPowerData, [name]: value });
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleCancelClick = () => {
    window.history.back();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!selectedProject) newErrors.selectedProject = "Project is required";

    if (!manPowerData.person_name?.trim()) {
      newErrors.person_name = "Person name is required";
    }

    if (!manPowerData.contact_no) {
      newErrors.contact_no = "Contact number is required";
    }

    if (!selectedPosition) {
      newErrors.selectedPosition = "Position is required";
    }

    if (!manPowerData.ec_no) {
      newErrors.ec_no = "EC No is required";
    }

    if (!selectedStatus) {
      newErrors.selectedStatus = "Status is required";
    }

    if (
      selectedStatus &&
      selectedStatus.value !== "Present at site" &&
      selectedStatus.value !== "Resigned" &&
      !selectedDate
    ) {
      newErrors.joining_expected_date = "Expected date of joining is required";
    }

    if (
      selectedStatus?.value === "Exited" &&
      selectedFiles.length === 0 &&
      !existingSiteFile
    ) {
      newErrors.site_clr_attachments = "Site clearance is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveClick = async (e) => {
    e?.preventDefault?.();

    if (!validateForm()) {
      return;
    }

    const formData = new FormData();

    // Ensure selectedPosition and manPowerData are correctly populated before appending data
    formData.append("project_id", projectId || ""); // Use manPowerData.project_id directly

    // Append other fields from state (ensure manPowerData is updated correctly)
    formData.append("person_name", manPowerData.person_name || ""); // Ensure default value if undefined
    formData.append("contact_no", manPowerData.contact_no || ""); // Ensure default value if undefined
    formData.append("email", manPowerData.email || ""); // Ensure default value if undefined
    formData.append("status", manPowerData.status || ""); // Ensure default value if undefined
    formData.append("ec_no", manPowerData.ec_no || ""); // Ensure default value if undefined
    // formData.append(
    //   "joining_expected_date",
    //   manPowerData.joining_expected_date || ""
    // ); // Ensure default value if undefined
    console.log("selectedPosition", selectedPosition);
    formData.append(
      "man_power_id",
      selectedPosition ? selectedPosition.value : null
    ); // Dynamically get value from selectedPosition

    if (
      selectedStatus?.value !== "Present at site" &&
      selectedStatus?.value !== "Resigned"
    ) {
      formData.append(
        "joining_expected_date",
        manPowerData.joining_expected_date || ""
      );
    }

    if (selectedStatus?.value === "Resigned") {
      formData.append(
        "excepted_date_leaving",
        manPowerData.leaving_expected_date || ""
      );
    }

    if (selectedFiles?.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("site_clr_attachments", file);
      });
    }

    if (selectedJoinFiles?.length > 0) {
      selectedJoinFiles.forEach((file) => {
        formData.append("joining_attachments", file);
      });
    }

    if (selectedResignedLetterFiles.length > 0) {
      selectedResignedLetterFiles.forEach((file) => {
        formData.append("resigned_letter", file);
      });
    }

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const response = await axios.put(
        `${API_URL}/api/update_actual_manpower/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: authKey,
          },
        }
      );

      console.log("Response:", response.data);
      setSnackbarMessage("Actual manpower updated successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => {
        navigate("/actual-manpowers");
      }, 1000);
    } catch (error) {
      console.error("Error response:", error.response);
      console.log("Project ID in payload:", manPowerData.project_id);
      console.log("Error data:", error?.response?.data);
      setSnackbarMessage(getBackendValidationMessage(error));
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const statusOptions = [
    { value: "Exited", label: "Exited" },
    { value: "Absconding", label: "Absconding" },
    { value: "Did not join", label: "Did not join" },
    { value: "Present at site", label: "Present at site" },
    { value: "Resigned", label: "Resigned" },
    {
      value: "Appointment issued (yet to join)",
      label: "Appointment issued (yet to join)",
    },
  ];

  const handleChange = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    setSelectedStatus(selectedOption);
    if (selectedOption && selectedOption.value === "Exited") {
      setShowAttachment(true);
    } else {
      setShowAttachment(false);
    }
    setManPowerData((prevState) => ({
      ...prevState,
      status: selectedOption ? selectedOption.value : "",
    }));
    setErrors((prevState) => ({
      ...prevState,
      selectedStatus: "",
      joining_expected_date: "",
      site_clr_attachments: "",
    }));
  };

  const handleUploadButtonClick = (inputRef) => {
    // This function handles the file upload button click
    // Open the file input dialog
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  const handleFileInputChange = (files, setFiles, errorField = null) => {
    const fileArray = Array.from(files);
    setFiles(fileArray);
    if (errorField && fileArray.length > 0) {
      setErrors((prevState) => ({
        ...prevState,
        [errorField]: "",
      }));
    }
  };
  const handleIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(true);
    setIsJoinPopupOpen(false);
  };
  const handleJoinIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(false);
    setIsJoinPopupOpen(true);
  };
  const handleDeleteFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handleCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleJoinDeleteFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedJoinFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedJoinFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedJoinFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      handleJoinCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };
  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const handleJoinCloseAttachment = () => {
    setIsJoinPopupOpen(false);
  };

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = date.toISOString().slice(0, 10);
      setSelectedDate(date);
      setManPowerData((prevState) => ({
        ...prevState,
        joining_expected_date: formattedDate,
      }));
    }
    setErrors((prevState) => ({
      ...prevState,
      joining_expected_date: "",
    }));
  };

  const handleLeavingDateChange = (date) => {
    console.log("date", date);
    if (date) {
      const formattedDate = date.toISOString().slice(0, 10);
      setSelectedLeavingDate(formattedDate);
      setManPowerData((prevState) => ({
        ...prevState,
        leaving_expected_date: formattedDate,
      }));
    }
  };

  const handleInstallationDateChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      setSelectedInstallationDate(date);
      setManPowerData((prevState) => ({
        ...prevState,
        passing_year: year,
      }));
    }
  };
  const handleBackProject = () => {
    window.history.back();
  };

  const fetchProjects = async () => {
    try {
      const authKey = localStorage.getItem("authKey"); // Retrieve auth key from local storage

      const response = await fetch(`${API_URL}/api/get_all_projects`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey, // Attach auth key in headers
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      const projectOptions = data.Projects.map((project) => ({
        value: project.id, // Unique identifier
        label: project.project_name, // Display name
      }));

      setProjects(projectOptions); // Update state with project options
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (projectId) {
      // Only fetch position data if project_id is available
      fetchPositionData(projectId);
    }
  }, [projectId]);

  const fetchPositionData = async (projectId) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/manpower_requirements/project`,
        {
          headers: { Authorization: authKey },
          params: { project_id: projectId },
        }
      );

      console.log("API response:", response.data);

      if (response.data.error) {
        console.warn("API error:", response.data.error);
        setPositionOptions([]);
        setSelectedPosition(null);
        return; // Stop
      }

      // Defensive fallback for empty Items
      if (!response.data.Items || response.data.Items.length === 0) {
        console.warn("No Items found for projectId:", projectId);
        setPositionOptions([]);
        setSelectedPosition(null);
        return; // Stop
      }

      const filteredOptions = response.data.Items.filter(
        (item) => item.project_id === projectId
      ).map((item) => ({
        value: item.id,
        label: item.position,
        project_id: item.project_id,
      }));

      console.log("Filtered options:", filteredOptions);

      setPositionOptions(filteredOptions);

      if (filteredOptions.length === 0) {
        setSelectedPosition(null);
      }

      const matchedPosition = filteredOptions.find(
        (option) => option.label === manPowerData.position
      );
      if (matchedPosition) {
        setSelectedPosition(matchedPosition);
      }
    } catch (error) {
      console.error("Error fetching position data:", error.message);
      setPositionOptions([]);
      setSelectedPosition(null);
    }
  };

  // const fetchPositionData = async (projectId) => {
  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     const response = await axios.get(
  //       `${API_URL}/api/manpower_requirements/project?project_id=${projectId}`,
  //       {
  //         headers: { Authorization: authKey },
  //       }
  //     );
  //     console.log("response.data.Items", projectId);
  //     console.log("response.data.Items", response.data);

  //     if (response.data.error) {
  //       console.warn("API error:", response.data.error);

  //       // Clear options + selected if backend says "not found"
  //       setPositionOptions([]);
  //       setSelectedPosition(null);
  //       return; // Stop here!
  //     }

  //     // Map fetched data to the required format for Select options
  //     const filteredOptions = response.data.Items.filter(
  //       (item) => item.project_id === projectId
  //     ) // Filter based on projectId
  //       .map((item) => ({
  //         value: item.id,
  //         label: item.position,
  //         project_id: item.project_id,
  //       }));

  //     setPositionOptions(filteredOptions);

  //     if (filteredOptions.length === 0) {
  //       // ✅ No positions → clear any stale value
  //       setSelectedPosition(null);
  //     }

  //     // If the fetched position matches the current manPowerData, set it as selected
  //     const matchedPosition = filteredOptions.find(
  //       (option) => option.label === manPowerData.position
  //     );
  //     if (matchedPosition) {
  //       setSelectedPosition(matchedPosition);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching position data:", error.message);
  //   }
  // };

  const handleProjectChange = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    setSelectedProject(selectedOption);
    setProjectId(selectedOption.value);
    setSelectedPosition(null); // ✅ Reset the position when project changes
    setErrors((prevState) => ({
      ...prevState,
      selectedProject: "",
      selectedPosition: "",
    }));
  };

  const handlePositionChange = (selectedOption) => {
    setSelectedPosition(selectedOption);
    setErrors((prevState) => ({
      ...prevState,
      selectedPosition: "",
    }));
  };

  const handleResignedLetterCLk = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(false);
    setIsResignedLetterPopupOpen(true);
  };

  const resignedLetterCloseAttachment = () => {
    setIsResignedLetterPopupOpen(false);
  };

  const resignedLetterDeleteFile = (indexToDelete) => {
    console.log("Delete function called for index:", indexToDelete);
    console.log("Before delete:", selectedResignedLetterFiles);

    // Filter out the file at the given index
    const updatedFiles = selectedResignedLetterFiles?.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setSelectedResignedLetterFiles(updatedFiles);
    console.log("After delete:", updatedFiles);

    // Check if no files remain, then close the popup
    if (updatedFiles.length === 0) {
      resignedLetterCloseAttachment(); // Close the popup if no files remain
      console.log("Popup closed");
    }
  };

  const handleResignedFileInputChange = (files) => {
    const fileArray = Array.from(files).slice(0, 1); // Only 1 file
    setSelectedResignedLetterFiles(fileArray);
    setExistingResignedLetterFile([]); // clear old
  };

  // const handleDeleteExistingFile = (id) => {
  //   setExistingResignedLetterFile((prev) =>
  //     prev.filter((file) => file.file_id !== id)
  //   );
  // };

  const handleDeleteExistingFile = (fileId) => {
    const updated = existingResignedLetterFile.filter((f) => f.id !== fileId);
    setExistingResignedLetterFile(updated);
    if (updated.length === 0) resignedLetterCloseAttachment();
  };

  const handleJoinFileInputChange = (files) => {
    setSelectedJoinFiles(Array.from(files));
    setExistingJoinFiles([]); // clear old
  };

  const handleDeleteExistingJoinFile = (fileId) => {
    const updated = existingJoinFiles.filter((f) => f.id !== fileId);
    setExistingJoinFiles(updated);
    if (updated.length === 0) handleJoinCloseAttachment();
  };

  return (
    <>
      <div
        className={`data-edit-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-edit-form-content">
          <div className="data-edit-form-header">
            <div className="data-edit-form-header-content">
              <div className="data-edit-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  {" "}
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBackProject}
                  />{" "}
                </Tooltip>
                Edit Actual Manpower
              </div>
              <div className="data-edit-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-edit-form-body">
            <form action="" onKeyDown={handleKeyDown}>
              <div className="new-data-form">
                <div className="form-group-select">
                  <label htmlFor="department_name">
                    Project<span className="text-danger">*</span>
                  </label>
                  <Select
                    id="project_name"
                    options={projects}
                    value={selectedProject}
                    onChange={handleProjectChange}
                    placeholder="Select Project"
                    isSearchable
                  />
                  {errors.selectedProject && (
                    <div className="error-message">
                      {errors.selectedProject}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="person_name">
                    Person Name<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="person_name"
                      value={manPowerData.person_name}
                      onChange={handleInputChange}
                      placeholder="Enter person name"
                    />
                  </div>
                  {errors.person_name && (
                    <div className="error-message">{errors.person_name}</div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="contact_no">
                    Contact No <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="contact_no"
                      value={manPowerData.contact_no}
                      onChange={handleInputChange}
                      placeholder="Enter contact number"
                    />
                  </div>
                  {errors.contact_no && (
                    <div className="error-message">{errors.contact_no}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <div className="input-group">
                    <input
                      type="email"
                      name="email"
                      value={manPowerData.email}
                      onChange={handleInputChange}
                      placeholder="Enter email"
                    />
                  </div>
                </div>
                <div className="form-group-select">
                  <label htmlFor="position">
                    Position<span className="text-danger">*</span>
                  </label>

                  <Select
                    id="EquipmentSubType"
                    value={selectedPosition}
                    options={positionOptions}
                    placeholder="Select position"
                    isSearchable
                    onChange={handlePositionChange}
                  />
                  {errors.selectedPosition && (
                    <div className="error-message">
                      {errors.selectedPosition}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="ec_no">
                    EC No <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="ec_no"
                      value={manPowerData.ec_no}
                      onChange={handleInputChange}
                      placeholder="Enter EC no"
                    />
                  </div>
                  {errors.ec_no && (
                    <div className="error-message">{errors.ec_no}</div>
                  )}
                </div>

                <div className="form-group-select">
                  <label htmlFor="status">
                    Current Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    id="currentStatus"
                    value={selectedStatus}
                    onChange={handleChange}
                    options={statusOptions}
                    placeholder="Select status..."
                    isClearable
                  />
                  {errors.selectedStatus && (
                    <div className="error-message">{errors.selectedStatus}</div>
                  )}
                </div>

                {selectedStatus?.value !== "Present at site" &&
                  selectedStatus?.value !== "Resigned" && (
                    <div className="form-group">
                      <label htmlFor="joining_expected_date">
                        Expected Date of Joining{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <DatePicker
                          selected={selectedDate}
                          onChange={handleDateChange}
                          name="joining_expected_date"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date"
                          className="datesss"
                          onKeyDown={(e) => {
                            if (e.key === "Backspace") {
                              setSelectedDate(null);
                            }
                          }}
                        />
                      </div>
                      {errors.joining_expected_date && (
                        <div className="error-message">
                          {errors.joining_expected_date}
                        </div>
                      )}
                    </div>
                  )}
                {selectedStatus?.value === "Exited" && (
                  <div className="form-group-attachments">
                    <div className="form-group">
                      <label htmlFor="site_clr_attachments">
                        Site Clearance <span className="text-danger">*</span>
                      </label>

                      {/* Upload Button */}
                      <button
                        type="button"
                        className="challan-btn"
                        onClick={() => handleUploadButtonClick(fileInputRef)}
                      >
                        <FiUpload /> Upload File
                      </button>

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        id="site_clr_attachments"
                        ref={fileInputRef}
                        onChange={(e) =>
                          handleFileInputChange(
                            e.target.files,
                            setSelectedFiles,
                            "site_clr_attachments"
                          )
                        }
                        style={{ display: "none" }}
                        multiple
                      />
                      {errors.site_clr_attachments && (
                        <div className="error-message">
                          {errors.site_clr_attachments}
                        </div>
                      )}

                      {/* File badge: count new or existing */}
                      {(selectedFiles.length > 0 || existingSiteFile) && (
                        <span
                          className="inquiry-file-btn-hr"
                          onClick={handleIconClick}
                        >
                          <MdAttachFile className="inquiry-file-icon" />{" "}
                          {selectedFiles.length > 0 ? selectedFiles.length : 1}
                        </span>
                      )}

                      {/* Attachments Popup */}
                      {isPopupOpen && (
                        <div className="attach-popup-amc1">
                          <div className="attach-popup-contant">
                            {/* Popup Header */}
                            <div className="attachment-header">
                              <div className="attachment-header-content">
                                Attachments
                              </div>
                              <button
                                className="fiile-close-btn"
                                onClick={handleCloseAttachment}
                              >
                                <IoCloseOutline className="file-close-icon" />
                              </button>
                            </div>

                            {/* Uploaded files if any */}
                            {selectedFiles.length > 0 && (
                              <div className="attach-scrroll-body">
                                {selectedFiles.map((file, index) => (
                                  <div
                                    className="attach-popup-contant-body"
                                    key={index}
                                  >
                                    <div className="attach-file-container">
                                      <div className="attach-file-show">
                                        <div className="text-attachment">
                                          {file.name}
                                        </div>
                                        <div className="text-attachment-file">
                                          File Size: {file.size} KB
                                        </div>
                                      </div>
                                      <div
                                        className="file-delete-btn"
                                        onClick={() => handleDeleteFile(index)}
                                      >
                                        <MdDeleteOutline className="file-delete-icon" />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Existing file if no new uploaded */}
                            {selectedFiles.length === 0 && existingSiteFile && (
                              <div className="attach-scrroll-body">
                                <div className="attach-popup-contant-body">
                                  <div className="attach-file-container">
                                    <div className="attach-file-show">
                                      <div className="text-attachment">
                                        {existingSiteFile.name ||
                                          existingSiteFile.filename}
                                      </div>
                                      <div className="text-attachment-file">
                                        File Size:{" "}
                                        {existingSiteFile.size ||
                                          existingSiteFile.file_size}{" "}
                                        KB
                                      </div>
                                    </div>
                                    <div
                                      className="file-delete-btn"
                                      onClick={() =>
                                        handleDeleteExistingFile(
                                          existingSiteFile.id
                                        )
                                      }
                                    >
                                      <MdDeleteOutline className="file-delete-icon" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  // <div className="form-group-attachments">
                  //   <div className="form-group">
                  //     <label htmlFor="site_clr_attachments">
                  //       Site Clearance <span className="text-danger">*</span>
                  //     </label>
                  //     <button
                  //       type="button"
                  //       className="challan-btn"
                  //       onClick={() => {
                  //         handleUploadButtonClick(fileInputRef);
                  //       }}
                  //     >
                  //       <FiUpload /> Upload File
                  //     </button>
                  //     <input
                  //       type="file"
                  //       id="site_clr_attachments"
                  //       ref={fileInputRef}
                  //       onChange={(e) =>
                  //         handleFileInputChange(
                  //           e.target.files,
                  //           setSelectedFiles
                  //         )
                  //       }
                  //       style={{ display: "none" }}
                  //       multiple
                  //     />
                  //     {selectedFiles.length > 0 && (
                  //       <span
                  //         className="inquiry-file-btn"
                  //         onClick={handleIconClick}
                  //       >
                  //         <MdAttachFile className="inquiry-file-icon" />{" "}
                  //         {`${selectedFiles.length}`}
                  //       </span>
                  //     )}
                  //     {isPopupOpen && (
                  //       <div className="attach-popup-amc1">
                  //         <div className="attach-popup-contant">
                  //           <div className="attachment-header">
                  //             <div className="attachment-header-content">
                  //               Attachments
                  //             </div>
                  //             <button
                  //               className="fiile-close-btn"
                  //               onClick={handleCloseAttachment}
                  //             >
                  //               <IoCloseOutline className="file-close-icon" />
                  //             </button>
                  //           </div>
                  //           {selectedFiles.length > 0 && (
                  //             <div className="attach-scrroll-body">
                  //               {selectedFiles.map((file, index) => (
                  //                 <div
                  //                   className="attach-popup-contant-body"
                  //                   key={index}
                  //                 >
                  //                   <div className="attach-file-container">
                  //                     <div className="attach-file-show">
                  //                       <div className="text-attachment">
                  //                         {file.name}
                  //                       </div>
                  //                       <div className="text-attachment-file">
                  //                         File Size:(
                  //                         {file.size} KB)
                  //                       </div>
                  //                     </div>
                  //                     <div
                  //                       className="file-delete-btn"
                  //                       onClick={() => handleDeleteFile(index)}
                  //                     >
                  //                       <span>
                  //                         {" "}
                  //                         <MdDeleteOutline className="file-delete-icon" />
                  //                       </span>
                  //                     </div>
                  //                   </div>
                  //                 </div>
                  //               ))}
                  //             </div>
                  //           )}
                  //         </div>
                  //       </div>
                  //     )}
                  //   </div>
                  // </div>
                )}

                {selectedStatus?.value === "Resigned" && (
                  <>
                    <div className="form-group">
                      <label htmlFor="leaving_expected_date">
                        Expected Date of Leaving{" "}
                      </label>
                      <div className="input-group">
                        <DatePicker
                          selected={selectedLeavingDate}
                          onChange={handleLeavingDateChange}
                          name="leaving_expected_date"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date"
                          className="datesss"
                          onKeyDown={(e) => {
                            if (e.key === "Backspace") {
                              setSelectedLeavingDate(null);
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group-attachments">
                      <div className="form-group">
                        <label htmlFor="resigned_letter">Resigned Letter</label>

                        {/* Upload Button */}
                        <button
                          type="button"
                          className="challan-btn"
                          onClick={() =>
                            handleUploadButtonClick(resignedletterFileInputRef)
                          }
                        >
                          <FiUpload /> Upload File
                        </button>

                        {/* Hidden File Input */}
                        <input
                          type="file"
                          id="resigned_letter"
                          ref={resignedletterFileInputRef}
                          onChange={(e) =>
                            handleResignedFileInputChange(e.target.files)
                          }
                          style={{ display: "none" }}
                          multiple={false} // resigned letter is usually a single file
                        />

                        {/* File badge: show count if any file exists */}
                        {(selectedResignedLetterFiles.length > 0 ||
                          existingResignedLetterFile) && (
                          <span
                            className="inquiry-file-btn-hr"
                            onClick={handleResignedLetterCLk}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {selectedResignedLetterFiles.length > 0
                              ? selectedResignedLetterFiles.length
                              : existingResignedLetterFile
                              ? 1
                              : 0}
                          </span>
                        )}

                        {/* Attachments Popup */}
                        {isResignedLetterPopupOpen && (
                          <div className="attach-popup-amc1">
                            <div className="attach-popup-contant">
                              {/* Popup Header */}
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={resignedLetterCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>

                              {/* Uploaded file(s) */}
                              {selectedResignedLetterFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedResignedLetterFiles.map(
                                    (file, index) => (
                                      <div
                                        className="attach-popup-contant-body"
                                        key={index}
                                      >
                                        <div className="attach-file-container">
                                          <div className="attach-file-show">
                                            <div className="text-attachment">
                                              {file.name}
                                            </div>
                                            <div className="text-attachment-file">
                                              File Size: {file.size} KB
                                            </div>
                                          </div>
                                          <div
                                            className="file-delete-btn"
                                            onClick={() =>
                                              resignedLetterDeleteFile(index)
                                            }
                                          >
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              )}

                              {/* Existing file if no new uploaded */}
                              {selectedResignedLetterFiles.length === 0 &&
                                existingResignedLetterFile && (
                                  <div className="attach-scrroll-body">
                                    <div className="attach-popup-contant-body">
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {existingResignedLetterFile.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:{" "}
                                            {existingResignedLetterFile.size} KB
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteExistingFile(
                                              existingResignedLetterFile.id
                                            )
                                          }
                                        >
                                          <MdDeleteOutline className="file-delete-icon" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {selectedStatus?.value !== "Resigned" && (
                  <div className="form-group-attachments">
                    <div className="form-group">
                      <label htmlFor="joining_attachments">
                        Joining Document
                      </label>

                      {/* Upload Button */}
                      <button
                        type="button"
                        className="challan-btn"
                        onClick={() =>
                          handleUploadButtonClick(joinFileInputRef)
                        }
                      >
                        <FiUpload /> Upload File
                      </button>

                      {/* Hidden File Input */}
                      <input
                        type="file"
                        id="joining_attachments"
                        ref={joinFileInputRef}
                        onChange={(e) =>
                          handleJoinFileInputChange(e.target.files)
                        }
                        style={{ display: "none" }}
                        multiple={true} // Joining docs can be multiple
                      />

                      {/* Badge */}
                      {(selectedJoinFiles.length > 0 ||
                        existingJoinFiles?.length > 0) && (
                        <span
                          className="inquiry-file-btn-hr"
                          onClick={handleJoinIconClick}
                        >
                          <MdAttachFile className="inquiry-file-icon" />{" "}
                          {selectedJoinFiles.length > 0
                            ? selectedJoinFiles.length
                            : existingJoinFiles?.length || 0}
                        </span>
                      )}

                      {/* Popup */}
                      {isJoinPopupOpen && (
                        <div className="attach-popup-amc1">
                          <div className="attach-popup-contant">
                            {/* Header */}
                            <div className="attachment-header">
                              <div className="attachment-header-content">
                                Attachments
                              </div>
                              <button
                                className="fiile-close-btn"
                                onClick={handleJoinCloseAttachment}
                              >
                                <IoCloseOutline className="file-close-icon" />
                              </button>
                            </div>

                            {/* Uploaded files */}
                            {selectedJoinFiles.length > 0 && (
                              <div className="attach-scrroll-body">
                                {selectedJoinFiles.map((file, index) => (
                                  <div
                                    className="attach-popup-contant-body"
                                    key={index}
                                  >
                                    <div className="attach-file-container">
                                      <div className="attach-file-show">
                                        <div className="text-attachment">
                                          {file.name}
                                        </div>
                                        <div className="text-attachment-file">
                                          File Size: {file.size} KB
                                        </div>
                                      </div>
                                      <div
                                        className="file-delete-btn"
                                        onClick={() =>
                                          handleJoinDeleteFile(index)
                                        }
                                      >
                                        <MdDeleteOutline className="file-delete-icon" />
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Existing files if no new uploaded */}
                            {selectedJoinFiles.length === 0 &&
                              existingJoinFiles?.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {existingJoinFiles.map((file) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={file.id}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size: {file.size} KB
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteExistingJoinFile(
                                              file.id
                                            )
                                          }
                                        >
                                          <MdDeleteOutline className="file-delete-icon" />
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-edit-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-edit-form-cancel-button"
                type="button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditActualManpower;
